<template>
    <v-row
        class="banner-carousel"
        :style="{
            'flex-grow':'0',
            'height':height,
            'min-height':height,
            'max-height':height,
            'background':backgroundColor,
            'color':textColor,
            'position': position !== 'none' ? 'fixed' : 'relative',
            'top':position === 'top' ? '0' :'auto',
            'bottom': position === 'bottom' ? '0' :'auto',
            'z-index':zIndex,
            'width':'100%',
            'padding':'0',
            'margin': '0',
        }"
        no-gutters
    >
        <v-col class="d-flex align-center overflow-hidden pa-0" :style="{ height:height }">
            <div v-if="items.length > 0" class="scroll-wrapper">
                <div
                    class="scroll-content"
                    ref="scrollContent"
                    @mouseenter="pause"
                    @mouseleave="resume"
                >
                    <!-- First set -->
                    <div class="item-set">
                        <div
                            v-for="(item, index) in items"
                            :key="'set1-' + index"
                            class="item-wrapper"
                            :style="{ minWidth: itemMinWidth }"
                        >
                            <slot name="item" :item="item">
                                <div>{{ item }}</div>
                            </slot>
                        </div>
                    </div>
                    <!-- Second set -->
                    <div class="item-set">
                        <div
                            v-for="(item, index) in items"
                            :key="'set2-' + index"
                            class="item-wrapper"
                            :style="{ minWidth:itemMinWidth }"
                        >
                            <slot name="item" :item="item">
                                <div>{{ item }}</div>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";
import emitter from "@/eventBus";

export default {
    name:"BannerCarousel",
    props:{
        apiEndpoint:{
            type:String,
            required: true,
        },
        transformData: {
            type: Function,
            default:null,
        },
        refetchOnLanguageChange:{
            type:Boolean,
            default:false,
        },
        height:{
            type:String,
            default:"60px",
        },
        backgroundColor:{
            type:String,
            default:"#0b2b5c",
        },
        textColor: {
            type: String,
            default:"#ffffff",
        },
        speed:{
            type:Number,
            default:5,
        },
        itemMinWidth:{
            type:String,
            default: "auto",
        },
        position:{
            type:String,
            default:"none",
            validator:(value) => ["top", "bottom", "none"].includes(value),
        },
        zIndex:{
            type:Number,
            default:99,
        },
    },
    data() {
        return {
            items:[],
        };
    },
    computed:{
        animationDuration() {
            return `${this.speed}s`;
        },
    },
    async created() {
        await this.fetchData();
    },
    mounted() {
        if (this.refetchOnLanguageChange) {
            emitter.on("language-changed", this.fetchData);
        }
    },
    beforeUnmount() {
        if (this.refetchOnLanguageChange) {
            emitter.off("language-changed", this.fetchData);
        }
    },
    methods: {
        async fetchData() {
            try {
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}${this.apiEndpoint}`
                );

                if (this.transformData) {
                    this.items = this.transformData(response.data);
                } else {
                    this.items = response.data;
                }
            } catch (error) {
                console.error("Failed to fetch banner data:", error);
            }
        },
        pause() {
            const content = this.$refs.scrollContent;
            if (content) {
                content.style.animationPlayState = "paused";
            }
        },
        resume() {
            const content = this.$refs.scrollContent;
            if (content) {
                content.style.animationPlayState = "running";
            }
        },
    },
};
</script>

<style scoped>
.banner-carousel {
    margin:0;
}

.scroll-wrapper {
    width:100%;
    height: 100%;
    overflow: hidden;
    position:relative;
    display:flex;
    align-items: center;
}

.scroll-content {
    display:flex;
    align-items:center;
    animation: scroll v-bind(animationDuration) linear infinite;
}

.item-set {
    display:flex;
    justify-content:space-around;
    align-items: center;
    min-width:100vw;
    flex-shrink:0;
}

@keyframes scroll {
    0% {
        transform:translateX(0);
    }
    100% {
        transform: translateX(-100vw);
    }
}

.item-wrapper {
    display:flex;
    align-items:center;
    justify-content:center;
    flex-shrink:0;
}
</style>
